export function obterListaMdfeTpComp() {
  return (
    [
      { label: '01 - Vale Pedágio', value: 'VALEPEDAGIO' },
      { label: '02 - Impostos, taxas e contribuições', value: 'IMPOSTOS' },
      { label: '03 - Despesas(bancárias, meios de pagamento, outras)', value: 'DESPESAS' },
      { label: '99 - Outros', value: 'OUTROS' },
    ]
  );
}
